import { updatePlaylistItem } from '../api/preference/playlist'
import useRequestState from './useRequestState'

export const useUpdatePlaylist = () => {
  const [updatePlaylist, requestState] = useRequestState(updatePlaylistItem)
  return [updatePlaylist, requestState]
}

export const dummy = () => {}
